module.exports = __webpack_public_path__ + "media/images/icons/delete-e53737fafcfe501c45efa2a1383758dc.svg";